import { render, staticRenderFns } from "./formuls-fraction-simple.vue?vue&type=template&id=43e677a8&scoped=true&"
import script from "./formuls-fraction-simple.vue?vue&type=script&lang=js&"
export * from "./formuls-fraction-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e677a8",
  null
  
)

export default component.exports